import { z } from "zod";

import { zodResolver } from "@mantine/form";

import i18n from "@/providers/i18n";

const loginFormSchema = zodResolver(
  z.object({
    email: z.string().email({ message: i18n.t("validation.errors.invalid-email") }),
    password: z.string().min(1, { message: i18n.t("validation.errors.min-length", { minLength: 1 }) }),
  }),
);

export default loginFormSchema;
